import React from 'react';
export function CourseCosts() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-955">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-956">
        <div className="mb-12" data-id="element-957">
          <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-958">
            Course Costs
          </h2>
          <div className="bg-white rounded-xl overflow-hidden shadow-sm border" style={{
          borderColor: '#ede9e0'
        }} data-id="element-959">
            <div className="overflow-x-auto" data-id="element-960">
              <table className="w-full text-left border-collapse" data-id="element-961">
                <thead data-id="element-962">
                  <tr style={{
                  backgroundColor: '#1e3d2f'
                }} data-id="element-963">
                    <th className="p-4 font-semibold text-sm uppercase tracking-wider" style={{
                    color: '#ffffff',
                    fontFamily: 'Inter, sans-serif'
                  }} data-id="element-964">
                      Membership
                    </th>
                    <th className="p-4 font-semibold text-sm uppercase tracking-wider" style={{
                    color: '#c8a84b',
                    fontFamily: 'Inter, sans-serif'
                  }} data-id="element-965">
                      Tuition
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-966">
                  <tr className="border-b" style={{
                  borderColor: '#ede9e0'
                }} data-id="element-967">
                    <td className="p-4 font-medium text-gray-800" data-id="element-968">
                      FLSC Members
                    </td>
                    <td className="p-4 font-bold text-[#1e3d2f]" data-id="element-969">$85.00</td>
                  </tr>
                  <tr className="border-b" style={{
                  borderColor: '#ede9e0'
                }} data-id="element-970">
                    <td className="p-4 font-medium text-gray-800" data-id="element-971">
                      Non-Members
                    </td>
                    <td className="p-4 font-bold text-[#1e3d2f]" data-id="element-972">$140.00</td>
                  </tr>
                  <tr data-id="element-973">
                    <td colSpan={2} className="p-4 text-sm text-gray-500 bg-gray-50 italic" data-id="element-974">
                      Tuition is non-refundable except in the case of a
                      cancelled class.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>;
}